module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_66.fe2de581.jpg";